import { render } from "./insure-team-report-add.vue?vue&type=template&id=368a79f5&scoped=true&ts=true"
import script from "./insure-team-report-add.vue?vue&type=script&lang=ts"
export * from "./insure-team-report-add.vue?vue&type=script&lang=ts"

import "./insure-team-report-add.vue?vue&type=style&index=0&id=368a79f5&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-368a79f5"]])

export default __exports__